import { Suspense } from "react";
import { useLocation } from "react-router-dom";
import TopBarProgress from "react-topbar-progress-indicator";
import { getCSSVariableValue } from "../../../_metronic/assets/ts/_utils";
import { ModuleErrorBoundary } from "./ModuleErrorBoundary";
import { GlobalErrorBoundary } from "./GlobalErrorBoundary.jsx";
import { GlobalErrorFallback } from "./GlobalErrorFallback.jsx";

/* ErrorBoundary barrel export
 *
 * Import from this file for clean imports:
 *   import { GlobalErrorBoundary, SuspensedView } from "../components/organisms/ErrorBoundary";
 */

export { GlobalErrorBoundary, GlobalErrorFallback };

// TopBarProgress is a singleton — configure once at module load, not inside a component.
// getCSSVariableValue is resolved here, so --bs-primary must be defined in the
// stylesheet before this module is first imported.
const baseColor = getCSSVariableValue("--bs-primary") || "#3e97ff";
TopBarProgress.config({
  barColors: {
    0: baseColor,
  },
  barThickness: 1,
  shadowBlur: 5,
});

const SuspensedView = ({ children, moduleName }) => {
  const { pathname } = useLocation();

  return (
    // key={pathname} forces ModuleErrorBoundary to fully remount on every
    // navigation, which resets hasError to false automatically.
    // This means navigating away from a broken page always shows the new page cleanly.
    <ModuleErrorBoundary key={pathname} moduleName={moduleName}>
      <Suspense fallback={<TopBarProgress />}>{children}</Suspense>
    </ModuleErrorBoundary>
  );
};

export { SuspensedView };
